import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import { MenuIcon } from '../../../images/shapes';

import Button from '../../Button/Button';
import PopoverComponent from '../../Popover/Popover';

const StatusbarActionMenu = ({ children, testId }) => {
  const { t } = useTranslation();

  return (
    <PopoverComponent
      popoverPanelPlacement="topLeft"
      popoverPhonePanelPlacement="topLeft"
      additionalPopoverPanelClasses="border-blue dark:border-blue "
      additionalClasses="z-0"
      {...getTestProps(testId, 'action-menu', 'testId')}
      popoverButton={
        <Button
          iconImage={<MenuIcon className="w-4 min-w-4" />}
          iconPosition="start"
          buttonSize="xs"
          as="span"
          additionalClasses="md:text-sm 2xl:text-base"
          additionalChildrenClasses="hidden xs:inline"
          additionalIconClasses="m-0 xs:mr-2"
          buttonColor="blueBordered"
        >
          {t('ObjectsOfType.Actions')}
        </Button>
      }
      content={children}
    />
  );
};

StatusbarActionMenu.propTypes = {
  /**
   * Statusbar action menu items
   */
  children: PropTypes.node,
  /**
   * test id
   */
  testId: PropTypes.string,
};

export default StatusbarActionMenu;
